import { Link } from "react-router-dom";
import styled from "styled-components";
import { LoggedIn } from "../../utils/helper";

const EditLink = ({ id }) => {

  const userLoggedIn = LoggedIn();
  if (!userLoggedIn) {
    return null;
  }

  return (
    <Wrapper>
      {
        <div className="edit-link">
          {userLoggedIn && <Link to={`/single/${id}`}>Edit</Link>}
        </div>
      }
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  align-items: left;
  div.edit-link {
    font-size: 12px;
  }
`;
export default EditLink;
